import * as types from './AuthenticationTypes';

export default function AuthenticationReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_AUTHENTICATION:
            return {
                ...state,
                getAuth: {
                    ...state.getAuth,
                    loading: false,
                    hasSuccess: true
                },
                signOut: {
                    ...state.signOut,
                    loading: false,
                    hasSuccess: false,
                    hasError: false
                },
            };
        case types.GET_AUTHENTICATION_LOADING:
            return {
                ...state,
                getAuth: {
                    ...state.getAuth,
                    loading: true
                },
            };
        case types.GET_AUTHENTICATION_ERROR:
            return {
                ...state,
                getAuth: {
                    ...state.getAuth,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        ...state.getAuth.hasError,
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_USER_AUTHENTICATED:
            return {
                ...state,
                userLogged: {
                    ...state.userLogged,
                    isLogged: true,
                    user: {
                        ...state.userLogged.user,
                        id: payload.user.uid,
                        administradorId: payload.data.administradorId,
                        nombre: payload.data.nombre,
                        apellido: payload.data.apellido,
                        email: payload.user.email,
                        emailVerified: payload.user.emailVerified,
                        avatar: payload.data.avatar,
                        role: payload.data.role,
                        pais: payload.data.pais ? payload.data.pais : "",
                        codigoPais: payload.data.pais ? payload.data.codigoPais : "",
                        status: payload.data.status,
                        lastConnection: payload.user.metadata.lastSignInTime,
                        createdAt: payload.user.metadata.creationTime
                    },
                    hasSuccess: true,
                    loading: false
                },
            };
        case types.GET_USER_AUTHENTICATED_LOADING:
            return {
                ...state,
                userLogged: {
                    ...state.userLogged,
                    loading: true
                },
            };
        case types.GET_USER_AUTHENTICATED_ERROR:
            return {
                ...state,
                userLogged: {
                    ...state.userLogged,
                    isLogged: false,
                    hasSuccess: false,
                    hasError: {
                        ...state.userLogged.hasError,
                        code: payload.code,
                        message: payload.message
                    },
                    loading: false
                },
            };
        case types.RECOVERY_PASSWORD:
            return {
                ...state,
                recoveryPassword: {
                    ...state.recoveryPassword,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.RECOVERY_PASSWORD_LOADING:
            return {
                ...state,
                recoveryPassword: {
                    ...state.recoveryPassword,
                    loading: true
                },
            };
        case types.RECOVERY_PASSWORD_ERROR:
            return {
                ...state,
                recoveryPassword: {
                    ...state.recoveryPassword,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.SIGNOUT_USER_AUTHENTICATED:
            return {
                ...state,
                getAuth: {
                    ...state.getAuth,
                    isLogged: false,
                    hasSuccess: false
                },
                user: {
                    ...state.userLogged.user,
                    id: null,
                    displayName: null,
                    email: null,
                    emailVerified: null,
                    lastConnection: null,
                    createdAt: null
                },
                signOut: {
                    ...state.signOut,
                    loading: false,
                    hasSuccess: true,
                    hasError: false
                },
            };
        case types.SIGNOUT_USER_AUTHENTICATED_LOADING:
            return {
                ...state,
                signOut: {
                    ...state.signOut,
                    loading: true
                },
            };
        case types.SIGNOUT_USER_AUTHENTICATED_ERROR:
            return {
                ...state,
                signOut: {
                    ...state.signOut,
                    loading: false,
                    hasSuccess: false,
                    hasError: true
                },
            };
        case types.AUTHENTICATION_RESET_STATE:
            return {
                ...state,
                getAuth: {
                    isLogged: false,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                recoveryPassword: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
    
        default:
            return state;
    }
}